import { Overlay } from "@mantine/core";

import { useSetLoginPopup }    from "_common/hooks/global";
import { useOpenProModal }     from "_common/hooks/useOpenProModal";
import { PrimaryButton }       from "_components/atoms/button";
import Icon                    from "_components/atoms/icon";
import Image                   from "_components/atoms/image";
import Render                  from "_components/atoms/render";
import Typography              from "_components/atoms/typography";
import { useSetAdWatchStatus } from "_jotai/rooterPro";

import useStyles from "./styles";

export const LOGIN_WALL = "loginWall";
export const DUPLICATE_STREAM_WALL = "duplicateStreamWall";
export const WATCH_AD_WALL = "watchAdWall";
export const BUY_PRO_WALL = "buyProWall";
export const PRO_EXPIRED_WALL = "proExpiredWall";

function component ( {
	canWatchMoreContent,
	background,
	children,
	isReel = false,
	zIndex,
	type
} ) {

	const setLoginModal    = useSetLoginPopup ();
	const { classes, cx }  = useStyles ( { isReel, zIndex }, { name: "login-wall" } );
	const openProModal     = useOpenProModal ();
	const setAdWatchStatus = useSetAdWatchStatus ();

	/* const buyProBtn = () => {
    // if(deviceType === "mobile")
    // {}
    const btnContent = (
      <PrimaryButton
        buttonTextClassName = { classes.btnText }
        className = { cx ( classes.buyProButton, classes.btn ) }
        rightSection = { (
          <Icon modeType = "dark"
            name = "caret"
            size = { 15 }
          />
        ) }
        onClick = { openProModal }
        leftSection = { (
          <Icon sameInBothTheme
            name = "proShineWhite"
            size = { 15 }
          />
        ) }
        title = { "Buy Pro" }
      />
    );

    if ( deviceType === "mobile" ) {
      return (
        <Link href = "/pro">
          {btnContent}
        </Link>
      );
    }

    return (
      <>
        { btnContent }
      </>
    );
  }; */

	const overlayDetails = {
		[LOGIN_WALL]: {
			title        : null,
			subtitle     : "Login to continue watching",
			btnEndIcon   : null,
			btnStartIcon : null,
			btnClassName : classes.btn,
			btnTitle     : "Login / Sign Up",
			onClick      : () => setLoginModal ( true )
		},
		[DUPLICATE_STREAM_WALL]: {
			title     : "Stream switched to another device.",
			subtitle  : "Please stop playing on other device and then try here.",
			ctaButton : null
		},
		[WATCH_AD_WALL]: {
			title        : "Free preview ended",
			subtitle     : "Watch AD to continue watching",
			btnEndIcon   : "caret",
			btnClassName : cx ( classes.buyProButton, classes.btn ),
			onClick      : () => setAdWatchStatus ( p => ( { ...p, opened: true } ) ),
			btnStartIcon : null,
			btnTitle     : "Watch Ad"
		},
		[BUY_PRO_WALL]: {
			title        : "Free preview ended",
			subtitle     : "Buy Pro to continue watching.",
			btnEndIcon   : "caret",
			btnClassName : cx ( classes.buyProButton, classes.btn ),
			onClick      : openProModal,
			btnStartIcon : "proShineWhite",
			btnTitle     : "Buy Pro"
		},
		[PRO_EXPIRED_WALL]: {
			title        : "Pro Expired",
			subtitle     : "Buy Pro to continue watching.",
			btnClassName : cx ( classes.buyProButton, classes.btn ),
			onClick      : openProModal,
			btnStartIcon : "proShineWhite",
			btnTitle     : "Buy Pro"
		}
	};

	return (
		<div className = { classes.loginWallWrapper }>
			<Render condition = { !canWatchMoreContent }>
				<div className = { classes.overlayOuter }>
					<Image className = { classes.wallBackground }
						src             = { background }
					/>

					<Overlay
						blur       = { 15 }
						classNames = { { root: classes.overlayRoot } }
					>
						<div className = { classes.overlayInner }>
							<Typography
								className = { classes.text2 }
								title     = { overlayDetails[type]?.title }
							/>

							<Typography
								className = { classes.text }
								title     = { overlayDetails?.[type]?.subtitle }
							/>

							<PrimaryButton
								buttonTextClassName = { classes.btnText }
								className           = { overlayDetails?.[type]?.btnClassName }
								id                  = { "watchAdButton" }
								leftSection         = { overlayDetails?.[type]?.btnStartIcon ? (
									<Icon sameInBothTheme
										name = { overlayDetails?.[type]?.btnStartIcon }
										size = { 15 }
									/>
								) : null }
								onClick             = { overlayDetails?.[type]?.onClick }
								rightSection        = { overlayDetails?.[type]?.btnEndIcon ? (
									<Icon modeType = "dark"
										name          = { overlayDetails?.[type]?.btnEndIcon }
										size          = { 15 }
									/>
								) : null }
								title               = { overlayDetails?.[type]?.btnTitle }
							/>

						</div>
					</Overlay>
				</div>
			</Render>

			{canWatchMoreContent ? children : null}
		</div>
	);
}

export default component;
